// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"styles-module__closeBtn___3m1OM"};